import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps } from '../../../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../../../utils/basecontext';
import { UIComponentView } from '../../../../../../toolkit/uicomponentview';
import { MultiselectCategoryCardViewImpl } from './multiselectcategorycardview';
import { UIComponentCSSStyle } from '../../../../../../toolkit/uicomponentcss';
import { CategoryDto } from '../../../../../../../core/dto/categories/categorydto';
import { MultiselectCategoryCardCSSStyleImpl } from './multiselectcategorycardcssstyle';

export interface MultiselectCategoryCardComponentProps extends UIComponentProps
{
    categoryDto: CategoryDto;
    position: number;
    isEditable: boolean;
    isSelected: boolean;

    onSelected(isSelected: boolean, categoryDto: CategoryDto): void;
}

export interface MultiselectCategoryCardComponentHandler extends UIComponentHandler
{
    onSelected(isSelected: boolean): void;
}

export class MultiselectCategoryCardComponent extends UIComponentImpl<MultiselectCategoryCardComponentProps, UIComponentState, UIDataModel> implements MultiselectCategoryCardComponentHandler
{
    constructor(props: MultiselectCategoryCardComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MultiselectCategoryCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MultiselectCategoryCardCSSStyleImpl(applicationContext);
    }

    onSelected(isSelected: boolean): void 
    {
       this.props.onSelected(isSelected, this.props.categoryDto);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectcategorycardcomponent.tsx